import React from 'react';
import './forms.css';

/** Decorative glyph: the control owns required/aria-required semantics and its name stays unchanged. */
export function RequiredIndicator({ required = true }) {
  return required ? <span className="bp-required-indicator" data-required-indicator="true" aria-hidden="true" title="Required" /> : null;
}
